import React from "react";

import edit_customisable_items from "./edit_customisable_items.png";

const EditCustomisableItems = () => (
  <div id="customisable_edit_resources" className="section">
    <h2>5.2 Edit Customisable Items</h2>
    <p>
      This section is found under <strong>Configuration</strong> on the{" "}
      <strong>manage portal</strong> menu and can be used to change the text on the Login, Welccome,
      FAQ & Help screens.
    </p>
    <p>
      Customisable items are grouped byHTML, Tet, Images or Email templates, each under their own
      tab.
    </p>
    <img src={edit_customisable_items} alt="Edit Resources" className="center" />
  </div>
);

export default EditCustomisableItems;
